import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const UploadFilled = ({
  size = 24,
  color = '#2075F0',
  ...props
}: IconProps) => {
  return (
    <Svg width={size} height={size} viewBox={`0 0 24 24`} {...props}>
      <G clip-path="url(#clip0_180_8433)">
        <Path
          d="M19.4403 11.69C19.4503 11.64 19.4503 11.57 19.4503 11.52C19.4503 7.74996 16.3903 4.70996 12.6403 4.70996C9.64031 4.70996 7.10031 6.63996 6.19031 9.32996C3.89031 9.51996 2.07031 11.46 2.07031 13.83C2.07031 16.32 4.09031 18.34 6.58031 18.34H18.6503C20.5103 18.34 22.0203 16.83 22.0203 14.97C22.0203 13.38 20.9203 12.04 19.4403 11.7V11.69ZM14.6203 12.59C14.4703 12.74 14.2803 12.81 14.0903 12.81C13.9003 12.81 13.7103 12.74 13.5603 12.59L12.7303 11.76V14.84C12.7303 15.25 12.3903 15.59 11.9803 15.59C11.5703 15.59 11.2303 15.25 11.2303 14.84V11.66L10.3303 12.56C10.0403 12.85 9.56031 12.85 9.27031 12.56C8.98031 12.27 8.98031 11.79 9.27031 11.5L11.4003 9.36996C11.6903 9.07996 12.1703 9.07996 12.4603 9.36996L14.6203 11.53C14.9103 11.82 14.9103 12.3 14.6203 12.59Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_180_8433">
          <Rect width="24" height="24" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default UploadFilled
